exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-number-filter-menu .k-filter-item-symbol{width:27px;text-align:center;display:inline-block;font-weight:500}\n", ""]);

// exports
